export const UPDATE_PASSWORD_PARAMS = 'UPDATE_PASSWORD_PARAMS';
export const UPDATE_PASSWORD_DONE = 'UPDATE_PASSWORD_DONE';
export const UPDATE_PASSWORD_ERROR = 'UPDATE_PASSWORD_ERROR';
export const UPDATE_PASSWORD_RESET = 'UPDATE_PASSWORD_RESET';
//# sourceMappingURL=actionTypes.js.map